import {Action} from "@/characters/model/Character.ts";
import MarkdownContent from "@/components/markdown/MarkdownContent.tsx";

export default function ActionView({action}: { action: Action }) {
    return <div className="leading-snug">
        <span className="text-[0.8125rem] font-bold" style={{fontVariant: "small-caps"}}>
            {action.name}.
        </span>
        <MarkdownContent markdown={action.value}
                         className="inline text-[0.8125rem] leading-snug [&_p]:mb-1.5 [&_ul]:my-1.5 [&>p:first-child]:ms-1.5 [&>p:first-child]:inline"/>
    </div>;
}
